export function isStandalone() {
    return navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
}

export function isPwaInstallButtonAvailable() {
    return window.__scDeferredInstallPrompt != null && !isStandalone();
}

/** Promo visibility follows install button availability (beforeinstallprompt + not standalone). */
export function isPwaInstallPlatformSupported() {
    return isPwaInstallButtonAvailable();
}

export function isPwaInstallAvailable() {
    return isPwaInstallButtonAvailable();
}

export function notifyGameFlash(method) {
    try {
        if (window.sc && typeof window.sc.flash === 'function') {
            const flash = window.sc.flash();
            if (flash && typeof flash[method] === 'function') {
                flash[method]();
            }
        }
    } catch (e) {
        console.error(e);
    }
}
